import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const OpenAccessIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.4178 13.25C15.4178 16.2875 12.9707 18.75 9.95201 18.75C6.93331 18.75 4.48617 16.2875 4.48617 13.25C4.48617 10.2124 6.93331 7.74998 9.95201 7.74998C12.9707 7.74998 15.4178 10.2124 15.4178 13.25Z"
        fill="var(--cdl-bg-faint)"
      />
      <path
        d="M14.5069 13.25C14.5069 10.7187 12.4676 8.66665 9.95201 8.66665C7.43642 8.66665 5.39714 10.7187 5.39714 13.25C5.39714 15.7813 7.43642 17.8333 9.95201 17.8333C12.4676 17.8333 14.5069 15.7813 14.5069 13.25ZM16.3288 13.25C16.3288 16.7938 13.4738 19.6666 9.95201 19.6666C6.43019 19.6666 3.5752 16.7938 3.5752 13.25C3.5752 9.70615 6.43019 6.83331 9.95201 6.83331C13.4738 6.83331 16.3288 9.70615 16.3288 13.25Z"
        fill="currentColor"
      />
      <path
        d="M11.774 13.25C11.774 14.2625 10.9582 15.0833 9.95201 15.0833C8.94577 15.0833 8.13006 14.2625 8.13006 13.25C8.13006 12.2375 8.94577 11.4166 9.95201 11.4166C10.9582 11.4166 11.774 12.2375 11.774 13.25Z"
        fill="var(--cdl-accent-bg-base)"
      />
      <path
        d="M10.863 13.25C10.863 12.7437 10.4551 12.3333 9.95201 12.3333C9.44889 12.3333 9.04103 12.7437 9.04103 13.25C9.04103 13.7562 9.44889 14.1666 9.95201 14.1666C10.4551 14.1666 10.863 13.7562 10.863 13.25ZM12.6849 13.25C12.6849 14.7688 11.4614 16 9.95201 16C8.44266 16 7.21909 14.7688 7.21909 13.25C7.21909 11.7312 8.44266 10.5 9.95201 10.5C11.4614 10.5 12.6849 11.7312 12.6849 13.25Z"
        fill="var(--cdl-accent-bg-base)"
      />
      <path
        d="M12.9127 9.12498V6.2604C12.9127 4.55177 11.5362 3.16665 9.83814 3.16665C8.65712 3.16665 7.62975 3.83665 7.11411 4.82363L5.50212 3.97052C6.32019 2.40465 7.95394 1.33331 9.83814 1.33331C12.5424 1.33331 14.7346 3.53924 14.7346 6.2604V9.12498C14.7346 9.63124 14.3268 10.0416 13.8236 10.0416C13.3205 10.0416 12.9127 9.63124 12.9127 9.12498ZM7.11411 4.82363C6.87999 5.27137 6.3298 5.44372 5.88465 5.20856C5.43933 4.97298 5.26801 4.41863 5.50212 3.97052L7.11411 4.82363Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default OpenAccessIcon;
